import * as z from "zod";
import { StorefrontPageGenericSectionDataSchema } from "./generic-section";

/** Custom JSX rendered below the cart line items. Its custom logic decides what, if anything, to show. */
export const CartWidgetSchema = StorefrontPageGenericSectionDataSchema.pick({
  jsx: true,
  props: true,
  customLogic: true,
});
export type CartWidget = z.infer<typeof CartWidgetSchema>;
